import { render, staticRenderFns } from "./landing-cananea.vue?vue&type=template&id=5ba4505f&scoped=true&"
import script from "./landing-cananea.vue?vue&type=script&lang=js&"
export * from "./landing-cananea.vue?vue&type=script&lang=js&"
import style0 from "./landing-cananea.vue?vue&type=style&index=0&id=5ba4505f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba4505f",
  null
  
)

export default component.exports